"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("@iov/crypto");
class AtomicSwapHelpers {
    static createPreimage() {
        return __awaiter(this, void 0, void 0, function* () {
            const bytes = crypto_1.Random.getBytes(32);
            return bytes;
        });
    }
    /** Creates a SHA256 hash of the preimage */
    static hashPreimage(preimage) {
        return new crypto_1.Sha256(preimage).digest();
    }
}
exports.AtomicSwapHelpers = AtomicSwapHelpers;
//# sourceMappingURL=atomicswaphelpers.js.map